import React from 'react';
import './WhatWeDoSection.css';

const WhatWeDoSection = () => {
  const features = [
    {
      icon: "⚡",
      title: "Personalised Dashboard"
    },
    {
      icon: "🎯",
      title: "Track of Work Status"
    },
    {
      icon: "🔒",
      title: "Document Repository"
    },
    {
      icon: "💬",
      title: "Chat & Support Integration"
    },
    {
      icon: "💰",
      title: "Account & Billing"
    },
    {
      icon: "📋",
      title: "Service Access based Plan"
    },
    {
      icon: "🌍",
      title: "Anytime Anywhere Access"
    },
    {
      icon: "🔔",
      title: "Timely reminders for compliances"
    }
  ];

  return (  
    <section className="what-we-do-section">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h2 className="section-title1">
              one stop portal for tax, compliances & beyond
            </h2>
            <div className="title-underline"></div>
            {/* <p className="section-subtitle">
              Experience comprehensive business solutions with our integrated platform
            </p> */}
          </div>
        </div>
        
        <div className="row">
          {features.map((feature, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-6 mb-4">
              <div className="feature-card">
                <div className="feature-icon">
                  <span className="icon-emoji">{feature.icon}</span>
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">{feature.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoSection;
